import { render, staticRenderFns } from "./indexTomaMuestras.vue?vue&type=template&id=760233e0&"
import script from "./indexTomaMuestras.vue?vue&type=script&lang=js&"
export * from "./indexTomaMuestras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports